export const entitySchema = {
  type: 'object',
  name: 'AuctionInsight',
  key: 'DisplayDomain',
  properties: {
    DisplayDomain: {
      type: 'string',
      filterable: true,
      nullable: false,
    },
    ImpressionShare: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
    AveragePosition: {
      type: 'number',
      filterable: true,
      nullable: false,
      required: true,
    },
    OverlapRate: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
    AboveRate: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
    TopOfPageRate: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
    AbsoluteTopOfPageRate: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
    OutrankingShare: {
      type: 'number',
      isPercentValue: true,
      filterable: true,
      nullable: false,
      required: true,
    },
  },
};
